import { gql } from "@apollo/client";

export const GET_PROGRAMA_PRE_PACIENTE = gql`
query GetAllProgramasPrePaciente {
    allProgramasPrePaciente
    {
        descripcion,
        abreviacion,
        idTipoModulo,
    }
}`;